import { API_BASIC_URL_SLOT_SERVICE, API_BASIC_URL_USER_MANAGEMENT } from "../config/constants";
import { handleError, handleResponseLogin } from "./ApiUtils";
import Fetch from "./Fetch";

export function login(userCredentials) {
  return Fetch.create(`${API_BASIC_URL_SLOT_SERVICE}/login`, userCredentials).then(handleResponseLogin).catch(handleError);
}

export function validateToken(requestURL) {
  return request(`${API_BASIC_URL_USER_MANAGEMENT}/api/v1/auth/login`, requestURL).then(handleResponseLogin).catch(handleError);
}

async function request(url, params) {
  const options = {
    method: "GET",
    headers: {
      Authorization: params.token,
    },
  };
  const response = await fetch(url, options);
  return response;
}
